export default __webpack_public_path__ + "static/media/darwinia-icon.0277bf40.svg";